import { useMsal } from "@azure/msal-react";
import axios from "axios";
import { useEffect, useState } from "react";
import { FiAlignRight, FiXCircle } from "react-icons/fi";
import { NavLink } from "react-router-dom";
import { baseUrl } from "../Constant";
import mailData from "./mailData";
import "./Navbarmenu.css";
const Navbarmenu = () => {
 const [isMenu, setisMenu] = useState(false);
 const [isResponsiveclose, setResponsiveclose] = useState(false);

 const { instance } = useMsal();
 const activeAccount = instance.getActiveAccount();
 let loggedInEnterpriseId = "";
 if (activeAccount) loggedInEnterpriseId = activeAccount.idTokenClaims.enterpriseID;
 const allowedUsersForContibution = [
  "aluru.akash",
  "ankur.e.mishra",
  "h.srinivasan",
  "jeevadharani.ramanan",
  "arpita.m.singh",
  "uma.rani.battu",
  "aayushi.bharti",
  "varsha.a.tyagi",
  "manika.madaan",
  "devika.gajanan.pote",
  "s.saraswathi",
  "niyati.deshmukh",
  "d.prashant.yende",
  "sonal.prakash.lad",
  "reshmi.haridas.m",
  "srikanth.narabathoju"
 ];
 //  const AdminUsers = ["reshmi.haridas.m", "uma.rani.battu"];

 const toggleClass = () => {
  setisMenu(isMenu === false ? true : false);
  setResponsiveclose(isResponsiveclose === false ? true : false);
 };
 let boxClass = ["main-menu"];
 if (isMenu) {
  boxClass.push("menuq2");
 } else {
  boxClass.push("");
 }

 const [isMenuSubMenu, setMenuSubMenu] = useState(false);
 const toggleSubmenu = () => {
  setMenuSubMenu(isMenuSubMenu === false ? true : false);
 };
 let boxClassSubMenu = ["sub__menus"];
 if (isMenuSubMenu) {
  boxClassSubMenu.push("sub__menus__Active");
 } else {
  boxClassSubMenu.push("");
 }
 const [temp, setTemp] = useState("");
 useEffect(() => {
  const homeUrl = async () => {
   const result = await axios.get(`${baseUrl}/homeUrl`);
   const {
    data: { Url },
   } = result;
   setTemp(Url);
  };
  homeUrl();
 }, []);
 return (
  <header className="header__middle">
   <div className="head-container">
    <div className="row-fluid">
     <div className="header__middle__menus">
      <nav className="main-nav ">
       {/* Responsive Menu Button */}
       {isResponsiveclose === true ? (
        <>
         <span
          className="menubar__button"
          style={{ display: "none" }}
          onClick={toggleClass}
         >
          <FiXCircle />
         </span>
        </>
       ) : (
        <>
         <span
          className="menubar__button"
          style={{ display: "none" }}
          onClick={toggleClass}
         >
          <FiAlignRight />
         </span>
        </>
       )}
       <ul className={boxClass.join(" ")}>
        <li className="menu-item">
         <a
          activeClassName="is-active"
          className="nav-links"
          onClick={toggleClass}
          href={temp ? temp : ""}
          target="_blank"
         >
          L&TT Home
         </a>
        </li>
        <li className="menu-item">
         <NavLink
          activeClassName="is-active"
          className="nav-links"
          onClick={toggleClass}
          to={`/home`}
         >
          Home
         </NavLink>
        </li>
        <li className="menu-item">
         <a
          activeClassName="is-active"
          className="nav-links"
          onClick={toggleClass}
          href="/home#about-us"
         >
          About Us
         </a>
        </li>
        <li className="menu-item">
         <a
          activeClassName="is-active"
          className="nav-links"
          onClick={toggleClass}
          href="/home#offerings"
         >
          Offerings
         </a>
        </li>
        <li className="menu-item">
         <NavLink
          activeClassName="is-active"
          className="nav-links"
          onClick={toggleClass}
          to={`/faq`}
         >
          FAQs
         </NavLink>
        </li>

        <li className="menu-item">
         <a
          activeClassName="is-active"
          className="nav-links"
          onClick={toggleClass}
          //href="mailto:atci.gendertechprgs@accenture.com"
          href={`mailto:${
           window.location.href.split(".")[3] === "staging"
            ? `${mailData.jeevadharani_ramanan};${mailData.reshmiharidas};${mailData.ankurmishra};${mailData.arpitasingh};${mailData.umaranibattu}`
            : `${mailData.atcigendertechprgs}`
          }`}
         >
          Contact Us
         </a>
        </li>
        {allowedUsersForContibution.includes(loggedInEnterpriseId) && (
         <li className="menu-item">
          <NavLink
           activeClassName="is-active"
           className="nav-links"
           onClick={toggleClass}
           to={`/analytics`}
          >
           Analytics
          </NavLink>
         </li>
        )}
        {/* {allowedUsersForContibution.includes(loggedInEnterpriseId) && (
                  <li className="menu-item">
                    <NavLink
                      activeClassName="is-active"
                      className="nav-links"
                      onClick={toggleClass}
                      to={`/admin`}
                    >
                      Admin
                    </NavLink>
                  </li>
                )} */}
       </ul>
      </nav>
     </div>
    </div>
   </div>
  </header>
 );
};

export default Navbarmenu;
